export function applyQuietUpdate(previous, data, context) {
  if (previous.origen !== context.loader || previous.token !== context.token) return previous;
  if (JSON.stringify(previous.data) === JSON.stringify(data)) return previous;
  return { ...previous, data };
}

// First response is a baseline, not a burst of historical notifications.
export function createNotificationTracker() {
  const seen = new Set();
  let initialized = false;
  return (notifications = []) => {
    const fresh = [];
    for (const notification of notifications) {
      if (!notification.id || seen.has(notification.id)) continue;
      seen.add(notification.id);
      if (initialized && !notification.readAt) fresh.push(notification);
    }
    initialized = true;
    return fresh.reverse();
  };
}

export function startVisiblePolling(task, {
  interval = 10_000, immediate = true, win = window, doc = document,
} = {}) {
  let stopped = false;
  let running = false;
  const refresh = async () => {
    if (stopped || running || doc.hidden) return;
    running = true;
    try { await task(() => !stopped); } catch { /* Retry on the next tick. */ }
    finally { running = false; }
  };
  const timer = win.setInterval(refresh, interval);
  win.addEventListener("focus", refresh);
  win.addEventListener("atlas:live-update", refresh);
  doc.addEventListener("visibilitychange", refresh);
  if (immediate) void refresh();
  return () => {
    stopped = true;
    win.clearInterval(timer);
    win.removeEventListener("focus", refresh);
    win.removeEventListener("atlas:live-update", refresh);
    doc.removeEventListener("visibilitychange", refresh);
  };
}
